import { createSlice } from '@reduxjs/toolkit';
import { SLICES } from '../../constants/slices';

const claimSlice = createSlice({
  name: SLICES.CLAIMS,
  initialState: {
    reimbursementDetails: {},
    customerClaimId: null
  },
  reducers: {
    setReimbursement: (state, action) => {
      const { hasNewReimbursement, newReimbursementDetails } = action.payload;
      state.reimbursementDetails = {
        hasNewReimbursement,
        newReimbursementDetails
      };
    },
    clearReimbursement: (state) => {
      state.reimbursementDetails = {};
    },
    setCustomerClaimId: (state, action) => {
      state.customerClaimId = action.payload;
    },
    clearCustomerClaimId: (state) => {
      state.customerClaimId = null;
    }
  }
});

export const { setReimbursement, clearReimbursement, setCustomerClaimId, clearCustomerClaimId } = claimSlice.actions;

export default claimSlice.reducer;
